<app-titledescription [title]="'Establecimientos'" [description]="'Aca se muestra el listado de establecimientos'"></app-titledescription>
<app-button
    text="Agregar Establecimiento"
    tooltip="Agregar nuevo establecimiento"
    href="/establecimientos/create"
></app-button>
<div style="margin-bottom: 20px;">
</div>
<ng-template #table>
@if(dataFetch) {
  <app-table
  [columnsNames]="columnNames"
  [dataFetch]="dataFetch"
  [totalItems]="totalItems"
  (fetchAgain)="fetchData($event.options, $event.ignoreCache)"
  [filterable]="true"
  [selectable]="false"
  [labelFilter]="'Descripción'"
  [actions]="actions"
  [apiService]="apiService"
  [paginateOptions]="paginateOptions"
  [pageIndex]="pageIndex"
  [mainFilterField]="'descripcion'"
  ></app-table>
}
</ng-template>
<app-card [templateRefContent]="table"></app-card>
